import React, { useState } from "react";
import { Button, ConfigProvider, Typography } from "antd";

const { Text } = Typography;

export default function CustomButton(props) {
  const [hover, setHover] = useState(false);

  const buttonStyle = props.style;

  const hoverStyle = {
    backgroundColor: props.hoverBackground,
  };

  const usedStyle = hover ? { ...buttonStyle, ...hoverStyle } : buttonStyle;

  return (
    <ConfigProvider
      theme={{
        token: {
          // colorPrimaryHover: "white",
        },
        components: {
          Button: {
            defaultBg: props.backgroundColor,
            colorText: props.colorText,
          },
        },
      }}
    >
      <Button
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        theme={props.theme}
        htmlType={props.htmlType}
        style={usedStyle}
        onClick={props.onClick}
        loading={props.isLoading}
        shape="round"
        className="of-primaryBtnColor"
      >
        {props.content}
      </Button>
    </ConfigProvider>
  );
}
